/* Clean Girl — global.js  (vanilla, sem dependências) */
(function () {
  'use strict';
  var CG = window.CG || {};
  var routes = CG.routes || { cart_url: '/cart', cart_add_url: '/cart/add', cart_change_url: '/cart/change' };
  var strings = CG.strings || {};
  var FREE_TARGET = Number(strings.freeShipTarget || 0); // em unidades monetárias (ex.: 129)

  function money(cents) {
    var v = (cents / 100);
    return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ---------------- Cart ---------------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function updateCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (el) {
      el.hidden = cart.item_count === 0;
    });
  }
  function addToCart(variantId, qty) {
    qty = qty || 1;
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'cart error'); });
      return r.json();
    }).then(function () {
      return fetchCart();
    }).then(function (cart) {
      updateCartUI(cart);
      showToast(cart);
      return cart;
    });
  }

  /* ---------------- Toast ---------------- */
  var toastEl, toastTimer;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'cg-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML =
      '<div class="cg-toast__head"><span>✓ ' + (strings.addedToBag || 'Adicionado à sacola') + '</span><span data-toast-name></span></div>' +
      '<div class="cg-toast__track"><div class="cg-toast__fill" data-toast-fill></div></div>' +
      '<div class="cg-toast__msg" data-toast-msg></div>' +
      '<a href="' + routes.cart_url + '">Finalizar compra</a>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(cart) {
    var el = ensureToast();
    var last = cart.items && cart.items.length ? cart.items[cart.items.length - 1] : null;
    el.querySelector('[data-toast-name]').textContent = last ? last.product_title : '';
    var msg = '';
    if (FREE_TARGET > 0) {
      var totalUnits = cart.total_price / 100;
      var pct = Math.min(100, Math.round((totalUnits / FREE_TARGET) * 100));
      el.querySelector('[data-toast-fill]').style.width = pct + '%';
      var falta = FREE_TARGET - totalUnits;
      msg = falta > 0 ? 'Faltam ' + money(falta * 100) + ' para o frete grátis' : '🎉 Você ganhou frete grátis!';
    } else {
      el.querySelector('[data-toast-fill]').style.width = '100%';
    }
    el.querySelector('[data-toast-msg]').textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4200);
  }

  /* ---------------- Delegated add-to-cart buttons ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variant = btn.getAttribute('data-variant-id');
    if (!variant) return;
    var qtyInput = btn.closest('[data-product-form]') ? btn.closest('[data-product-form]').querySelector('[data-qty-input]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var original = btn.textContent;
    btn.disabled = true;
    addToCart(variant, qty).then(function () {
      btn.disabled = false;
    }).catch(function (err) {
      btn.disabled = false;
      console.warn('Clean Girl cart:', err.message);
      alert('Não foi possível adicionar ao carrinho. Tente novamente.');
    });
  });

  /* ---------------- Mobile nav ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { var m = document.querySelector('.cg-mnav'); if (m) m.classList.add('is-open'); }
    if (e.target.closest('[data-menu-close]')) { var m2 = document.querySelector('.cg-mnav'); if (m2) m2.classList.remove('is-open'); }
  });

  /* ---------------- Featured rail arrows ---------------- */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var scope = rail.closest('[data-rail-scope]') || document;
    scope.querySelectorAll('[data-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -380, behavior: 'smooth' }); }); });
    scope.querySelectorAll('[data-rail-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: 380, behavior: 'smooth' }); }); });
  });

  /* ---------------- Testimonials carousel ---------------- */
  document.querySelectorAll('[data-testi]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-testi-item]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testi-dot]'));
    var fill = root.querySelector('[data-testi-fill]');
    if (items.length <= 1) { if (fill) fill.style.width = '100%'; return; }
    var i = 0, tick = 0, paused = false, timer;
    function show(n) {
      i = (n + items.length) % items.length; tick = 0;
      items.forEach(function (el, k) { el.hidden = k !== i; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (fill) fill.style.width = '0%';
    }
    root.querySelectorAll('[data-testi-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); }); });
    root.querySelectorAll('[data-testi-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    show(0);
    timer = setInterval(function () {
      if (paused) return;
      tick++;
      if (fill) fill.style.width = Math.min(100, tick * 2) + '%';
      if (tick >= 50) show(i + 1);
    }, 100);
  });

  /* ---------------- Product page ---------------- */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    // Gallery
    var mainImg = pdp.querySelector('[data-gallery-main]');
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (mainImg && full) { mainImg.src = full; mainImg.style.animation = 'none'; void mainImg.offsetWidth; mainImg.style.animation = ''; }
        pdp.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    // Qty stepper
    var qtyInput = pdp.querySelector('[data-qty-input]');
    pdp.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value, 10) || 1;
        v += parseInt(b.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.max(1, v);
      });
    });

    // Variant selection (updates hidden id, price, add buttons)
    var variantsData = [];
    try { variantsData = JSON.parse(pdp.querySelector('[data-variants-json]').textContent); } catch (e) {}
    function currentSelected() {
      var chosen = {};
      pdp.querySelectorAll('[data-option-index]').forEach(function (group) {
        var sel = group.querySelector('[aria-current="true"]');
        if (sel) chosen[group.getAttribute('data-option-index')] = sel.getAttribute('data-value');
      });
      return chosen;
    }
    function matchVariant() {
      var chosen = currentSelected();
      return variantsData.find(function (v) {
        return Object.keys(chosen).every(function (idx) { return v.options[idx] === chosen[idx]; });
      });
    }
    function applyVariant() {
      var v = matchVariant();
      if (!v) return;
      pdp.querySelectorAll('[data-variant-id]').forEach(function (el) { el.setAttribute('data-variant-id', v.id); });
      var idField = pdp.querySelector('[data-selected-variant]');
      if (idField) idField.value = v.id;
      var priceEl = pdp.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = money(v.price);
      var parcelEl = pdp.querySelector('[data-parcel]');
      if (parcelEl) parcelEl.textContent = money(Math.round(v.price / 3));
      var addBtn = pdp.querySelector('[data-add-to-cart]');
      if (addBtn) { addBtn.disabled = !v.available; if (!v.available) addBtn.textContent = 'Esgotado'; }
      if (mainImg && v.featured_image) { mainImg.src = v.featured_image; }
    }
    pdp.querySelectorAll('[data-option-index] [data-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var group = opt.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        opt.setAttribute('aria-current', 'true');
        var label = group.parentNode.querySelector('[data-option-value-label]');
        if (label) label.textContent = opt.getAttribute('data-value');
        applyVariant();
      });
    });

    // Buy now → add then go to checkout
    var buyBtn = pdp.querySelector('[data-buy-now]');
    if (buyBtn) buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = buyBtn.getAttribute('data-variant-id');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      buyBtn.disabled = true;
      addToCart(vid, qty).then(function () { window.location.href = routes.cart_url; })
        .catch(function () { buyBtn.disabled = false; alert('Não foi possível continuar. Tente novamente.'); });
    });
  }

  // Initial cart sync (keeps header count correct across pages)
  fetchCart().then(updateCartUI).catch(function () {});
})();
